<div class="theme-package-selector">
  <label for="theme-package-select">Theme Package:</label>
  <select
    id="theme-package-select"
    [(ngModel)]="currentThemePackage"
    (change)="changeThemePackage(currentThemePackage)"
    class="form-select"
    >
    @for (pkg of availableThemePackages; track pkg) {
      <option [value]="pkg.id">
        {{ pkg.name }}
      </option>
    }
  </select>
</div>
